module.exports = __webpack_public_path__ + "img/hr-tree-04-c-leaves.90f4a601.png";